<template>
	<svg viewBox="0 0 17 32">
		<slot></slot>
		<path d="M16.826 25.75l-10.396 6.25 2.704-11.808-9.134-7.962 12.079-1.052 4.747-11.147v25.72z" />
	</svg>
</template>
